import { Directive, ElementRef, Attribute } from '@angular/core';
import { uniqueId } from './util';
var NgxCardNumberTemplate = (function () {
    function NgxCardNumberTemplate(elementRef, name) {
        this.elementRef = elementRef;
        this.name = name;
    }
    NgxCardNumberTemplate.prototype.ngOnInit = function () {
        this.name = this.name || uniqueId('number');
    };
    return NgxCardNumberTemplate;
}());
export { NgxCardNumberTemplate };
NgxCardNumberTemplate.decorators = [
    { type: Directive, args: [{
                selector: '[card-number]',
                host: {
                    '[name]': 'name',
                },
            },] },
];
/** @nocollapse */
NgxCardNumberTemplate.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: undefined, decorators: [{ type: Attribute, args: ['name',] },] },
]; };
var NgxCardNameTemplate = (function () {
    function NgxCardNameTemplate(elementRef, name) {
        this.elementRef = elementRef;
        this.name = name;
    }
    NgxCardNameTemplate.prototype.ngOnInit = function () {
        this.name = this.name || uniqueId('name');
    };
    return NgxCardNameTemplate;
}());
export { NgxCardNameTemplate };
NgxCardNameTemplate.decorators = [
    { type: Directive, args: [{
                selector: '[card-name]',
                host: {
                    '[name]': 'name',
                },
            },] },
];
/** @nocollapse */
NgxCardNameTemplate.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: undefined, decorators: [{ type: Attribute, args: ['name',] },] },
]; };
var NgxCardExpiryTemplate = (function () {
    function NgxCardExpiryTemplate(elementRef, name) {
        this.elementRef = elementRef;
        this.name = name;
    }
    NgxCardExpiryTemplate.prototype.ngOnInit = function () {
        this.name = this.name || uniqueId('expiry');
    };
    return NgxCardExpiryTemplate;
}());
export { NgxCardExpiryTemplate };
NgxCardExpiryTemplate.decorators = [
    { type: Directive, args: [{
                selector: '[card-expiry]',
                host: {
                    '[name]': 'name',
                },
            },] },
];
/** @nocollapse */
NgxCardExpiryTemplate.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: undefined, decorators: [{ type: Attribute, args: ['name',] },] },
]; };
var NgxCardCvcTemplate = (function () {
    function NgxCardCvcTemplate(elementRef, name) {
        this.elementRef = elementRef;
        this.name = name;
    }
    NgxCardCvcTemplate.prototype.ngOnInit = function () {
        this.name = this.name || uniqueId('cvc');
    };
    return NgxCardCvcTemplate;
}());
export { NgxCardCvcTemplate };
NgxCardCvcTemplate.decorators = [
    { type: Directive, args: [{
                selector: '[card-cvc]',
                host: {
                    '[name]': 'name',
                },
            },] },
];
/** @nocollapse */
NgxCardCvcTemplate.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: undefined, decorators: [{ type: Attribute, args: ['name',] },] },
]; };
//# sourceMappingURL=inputs.js.map